import { DashboardRouter } from 'app/Dashboard/dashboardRouter';
import { AutenticationRouter } from 'app/autentication/autenticationRouter';
import { CashFlowRouter } from 'app/cashFlow/cashFlowRouter';
import { ConfigurationRouter } from 'app/configuration/configuration';
import { ElectronicBillingRouter } from 'app/electronicBilling/electronicBillingRouter';
import { InventoryRouter } from 'app/inventory/inventoryRouter';
import { ReportRouter } from 'app/report/reportRouter';
import { SaleRouter } from 'app/sale/saleRouter';
import { GlobalContext } from 'context';
import { ModuleRoute } from 'module-routes';
import { es } from 'date-fns/locale';
import { FC, ReactElement } from 'react';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorPageProvider from 'shared/components/ErrorPageProvider/ErrorPageProvider';
import Layout from 'shared/components/Layout/Layout';
import Loading from 'shared/components/Loading/Loading';
import ModalDialogue from 'shared/components/ModalDialogue/ModalDialogue';
import useDispatchState from 'shared/hooks/useDispatchState';
import createPrivateRouteUsignContext from 'shared/utils/PrivateRouteCreator/PrivateRouteCreator';
import { navigate } from 'shared/utils/navigate';
import { GlobalAction } from 'store/global-actions';

const DATE_PICKER_LOCALE = 'es';

registerLocale(DATE_PICKER_LOCALE, es);
setDefaultLocale(DATE_PICKER_LOCALE);

const PrivateRoute = createPrivateRouteUsignContext({
  context: GlobalContext,
  accessWith: (context): boolean => !!context.state.accessUser,
  otherwiseRedirectTo: () => navigate('/login'),
});

const App: FC = (): ReactElement => {
  const [{ pendingFetches, modalAlert }, dispatchApp] = useDispatchState(GlobalContext);

  return (
    <>
      <Loading show={pendingFetches > 0} />
      <ToastContainer autoClose={3000} />
      <ErrorPageProvider>
        <Routes>
          <Route path={`${ModuleRoute.Login}/*`} element={<AutenticationRouter />} />
          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                  <Route element={<PrivateRoute />}>
                    <Route path={`${ModuleRoute.Dashboard}/*`} element={<DashboardRouter />} />
                    <Route path={`${ModuleRoute.Configuration}/*`} element={<ConfigurationRouter />} />
                    <Route path={`${ModuleRoute.Inventory}/*`} element={<InventoryRouter />} />
                    <Route path={`${ModuleRoute.Sale}/*`} element={<SaleRouter />} />
                    <Route path={`${ModuleRoute.CashFlow}/*`} element={<CashFlowRouter />} />
                    <Route path={`${ModuleRoute.Report}/*`} element={<ReportRouter />} />
                    <Route path={`${ModuleRoute.ElectronicBilling}/*`} element={<ElectronicBillingRouter />} />
                  </Route>
                  <Route path="*" element={<Redirect to={ModuleRoute.Login} replace />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </ErrorPageProvider>
      {modalAlert && (
        <ModalDialogue
          {...{
            ...modalAlert,
            primaryAction: () => {
              modalAlert.primaryAction(dispatchApp);
              dispatchApp({ type: GlobalAction.SetModalAlert, payload: null });
            },
          }}
          isVisible
          size="sm"
        />
      )}
    </>
  );
};

export default App;
